import { EuiButton, EuiButtonProps } from '@elastic/eui';
import { useRouter } from 'next/router';

type EuiLinkButtonProps = Omit<EuiButtonProps, 'onClick'> & {
  href: string;
};

const EuiLinkButton: React.FC<EuiLinkButtonProps> = props => {
  const router = useRouter();

  const handleClick = (event: React.MouseEvent) => {
    event.preventDefault();
    router.push(props.href);
  };

  return <EuiButton {...props} onClick={handleClick} />;
};

export default EuiLinkButton;
